import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { designation_details } from "../../../core/data/json/designation_details";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {exportToCSV,exportToExcel} from "../../../core/common/GlobalFunctions/exportTableData";
import { Drawer, message } from "antd";
import {fetchALlSkill,createSkill,UpdateSkills,deleteSkill} from "../../../core/data/redux/skill/skill.Action";
import { formatDate } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { decryptData } from "../../../core/utils/encryptUtils";

const Skill = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const Id = selectedRowData?.Id;
  const { user } = useSelector((state: any) => state.auth);
  const { skill, loadingStates } = useSelector((state: any) => state.skill);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
  const [errors, setErrors] = useState<any>({});

  // Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetForm(); 
  };

  const handleEditDesignation = (record: any): void => {
    setSelectedRowData(record);
    setErrors({});
  };

  const [statusName, setStatusName] = useState("");
  const [statusDescription, setStatusDescription] = useState<any>("");
  const [status, setStatus] = useState<any>("");
  const [allskills, setallSkills] = useState<any>("");

  const resetForm = () => {
  setStatusName("");  // Reset skill name
  setStatusDescription("");  // Reset skill description
  setStatus("");  // Reset status
  setErrors({});  // Reset errors
  setSelectedRowData(null);  // Clear the selected row data
};

  const handleEditSkill = (record: any): void => {
    setSelectedRowData(record);
    setStatusName(record.Name || "");
    setStatusDescription(record.description || "");
    setStatus(record.status || "");
  };

  const handleDeleteSkill = (id: any) => {
    const skillId = id;
    dispatch(deleteSkill(skillId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchALlSkill()).then((res) => {
            setallSkills(res.payload.data);
          });
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleSubmit = () => {
    const validationErrors: any = {};
    if (!statusName.trim()) {
      validationErrors.statusName = "Name is required";
    }
    if (!status.trim()) {
      validationErrors.status = "Status is required";
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    const formData = {
      Name: statusName,
      Description: statusDescription,
      status: status,
      ...(selectedRowData
        ? { modifiedBy: user.UserId }
        : { createdBy: user.UserId }),
    };

    if (selectedRowData) {
      dispatch(UpdateSkills({ id: Id, data: formData })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          resetForm();
          handleCancel();
          dispatch(fetchALlSkill()).then((res) => {
            setallSkills(res.payload.data);
          });
        } else {
          message.warning(res.payload.message);
        }
      });
    } else {
      dispatch(createSkill(formData)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          setStatusName("");
          setStatusDescription("");
          setStatus("");
          handleCancel();
          dispatch(fetchALlSkill()).then((res) => {
            setallSkills(res.payload.data);
          });
        } else {
          message.warning(res.payload.message);
        }
      });
    }
  };

  useEffect(() => {
    dispatch(fetchALlSkill()).then((res) => {
      setallSkills(res.payload.data);
    });
  }, []);

  useEffect(() => {
    if (selectedRowData) {
      setStatusName(selectedRowData.Name || "");
      setStatusDescription(selectedRowData.description || "");
      setStatus(selectedRowData.status || "");
    }
  }, [selectedRowData]);

  const data = allskills ? allskills : [];
  const config = useAppConfig() ?? {};

  const exportSkill = data.map((item: any) => ({
    Id: item.Id,
    Name: item.Name || "N/A",
    description: item.description || "N/A",
    status: item.status || "N/A",
    CreatedAt: formatDate(item.createdAt || item.CreatedAt, config),
  }));


  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [dispatch, allskills, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [allskills, selectedStatus, selectedSort, dispatch]);

  const columns = [
    {
      title: "Skill",
      dataIndex: "Name",
      sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text: string) => (
        <h6 className="fw-medium fs-14 text-dark">
          {text?.trim() ? text : "No Description"}
        </h6>
      ),
      sorter: (a: any, b: any) =>
        (a.description?.length || 0) - (b.description?.length || 0),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Button */}
          <button
            className="me-2"
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditDesignation(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canEdit ? "Permission Denied" : "Edit Skill"}
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete Button */}
          <button
            onClick={() => {
              if (!canDelete || record.status === "inactive") return;
              setSelectedRowData(record);
              handleEditSkill(record);
              setIsDeleteModalVisible(true);
            }}
            className="me-2"
            disabled={!canDelete || record.status === "inactive"}
            style={{
              cursor:
                !canDelete || record.status === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity: !canDelete || record.status === "inactive" ? 0.5 : 1,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={
              !canDelete
                ? "Permission Denied"
                : record.status === "inactive"
                  ? "Skill is inactive"
                  : "Delete Skill"
            }
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Skill</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Skills
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportSkill, "Skill_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportSkill, "Skill_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    onClick={() => showModal("create")}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Skill
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Skill List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  {/* <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Department
                  </Link> */}
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Finance
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Application Development
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Designation */}
      <Drawer
        title={modalType === "edit" ? "Edit Skill" : "Add Skill"}
        placement="right"
        width={400}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={statusName}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^[a-zA-Z\s]*$/.test(input)) {
                        setStatusName(input);
                      }
                    }}
                    className="form-control"
                  />

                  {errors.statusName && (
                    <div style={{ color: "red" }}>{errors.statusName}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                  {errors.status && (
                    <div style={{ color: "red" }}>{errors.status}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description
                  </label>
                  <input
                    type="text"
                    value={statusDescription}
                    onChange={(e) => setStatusDescription(e.target.value)}
                    className="form-control"
                  />
                  {errors.statusDescription && (
                    <div style={{ color: "red" }}>
                      {errors.statusDescription}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit} disabled={isLoading}
            >{isLoading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit" ? "Update Skill" : "Add Skill"}
            </button>
          </div>
        </form>
      </Drawer>
      {/* /Add Designation */}

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeleteSkill(selectedRowData.Id)
        }
      />
    </>
  );
};
export default Skill;
